// The variants are actually imported by the theme, but colocating helps finding them more easily.
export default {
    _base: {
        fontFamily: 'body',
        fontWeight: 'body',
        textTransform: 'uppercase',
    },
    large: {
        variant: 'label._base',
        fontSize: 'default',
        lineHeight: 'default',
        letterSpacing: 1,
    },
    default: {
        variant: 'label._base',
        fontSize: 'smallest',
        lineHeight: 'smallest',
        letterSpacing: 1,
    },
    small: {
        variant: 'label._base',
        fontSize: 10,
        lineHeight: '16px',
        letterSpacing: 0.8,
    },
    radio: {
        variant: 'label._base',
        fontSize: 'smallest',
        lineHeight: 'smallest',
        letterSpacing: 'smallest',
    },
};
//# sourceMappingURL=labelVariants.js.map